// components/PropertyIssues/IssuesFilters.jsx
import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";

const ASSIGNED_TO_OPTIONS = ["IT", "Operations", "Facilities", "Marketing"];

export default function IssuesFilters({ vendors, filter, setFilter }) {
  const set = (k, v) => setFilter((prev) => ({ ...prev, [k]: v }));

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ mb: 1 }}>
      <FormControl size="small" sx={{ minWidth: 160 }}>
        <InputLabel id="f-status">Status</InputLabel>
        <Select
          labelId="f-status"
          label="Status"
          value={filter.status}
          onChange={(e) => set("status", e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {[
            "not reported",
            "reported",
            "pending estimate",
            "pending approval",
            "pending vendor arrival",
            "work in progress",
            "completed",
          ].map((s) => (
            <MenuItem key={s} value={s}>
              {s}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel id="f-priority">Priority</InputLabel>
        <Select
          labelId="f-priority"
          label="Priority"
          value={filter.priority}
          onChange={(e) => set("priority", e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="low">Low</MenuItem>
          <MenuItem value="medium">Medium</MenuItem>
          <MenuItem value="high">High</MenuItem>
          <MenuItem value="urgent">Urgent</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel id="f-assigned-to">Assigned To</InputLabel>
        <Select
          labelId="f-assigned-to"
          label="Assigned To"
          value={filter.assignedTo}
          onChange={(e) => set("assignedTo", e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {ASSIGNED_TO_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="f-vendor">Vendor</InputLabel>
        <Select
          labelId="f-vendor"
          label="Vendor"
          value={filter.vendor}
          onChange={(e) => set("vendor", e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {vendors.map((v) => (
            <MenuItem key={v.id} value={v.name}>
              {v.name}
            </MenuItem>
          ))}
          <MenuItem value="unknown">unknown</MenuItem>
          <MenuItem value="TBD">TBD</MenuItem>
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Search details…"
        value={filter.search}
        onChange={(e) => set("search", e.target.value)}
      />
    </Stack>
  );
}
